import { Injectable, inject } from '@angular/core';
import { getYear } from 'date-fns';
import { Subject } from 'rxjs';
import { FilterConfig } from '../interfaces/filter-config';
import { SiaSessionParam } from '../interfaces/sia-session-param';
import { SiaDateService } from './date.service';
import { SiaParamsAndPatternsService } from './params-and-patterns.service';
import { SiaUsersService } from './users.service';

@Injectable({
  providedIn: 'root',
})
export class SiaPreFiltersService {
  private dateService = inject(SiaDateService);
  private usersService = inject(SiaUsersService);
  private pAndPService = inject(SiaParamsAndPatternsService);

  today = '#Today';
  todayDeprectaed = '@Today';
  foy = '#FirstOfYear';
  foyDeprectaed = '@FirstOfYear';
  cyn = '#CurrentYearNumber';
  cynDeprecated = '@CurrentYearNumber';
  uId = '#UserId';
  uIdDeprecated = '@UserId';
  relId = '#RelationId';
  relIdDeprecated = '@RelationId';
  sessionParam = 'SessionParam';
  sessionParamDeprecated = '@SessionParam';
  staticValue = 'StaticValue';
  staticValueDeprecated = '@StaticValue';

  private _popup$: Subject<boolean> = new Subject<boolean>();

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  get popUpToggle$() {
    return this._popup$.asObservable();
  }

  //#region  private methods
  private getUserId(): any {
    var user = this.usersService.getUserData();
    // if (
    //   this.securedShareSiaSessionService &&
    //   this.securedShareSiaSessionService.getSharedLoggedUser()
    // )
    //   return this.securedShareSiaSessionService.getLoggedUser().id;
    if (user) return user.id;
    return null;
  }
  private getFirstOfYear() {
    return new Date(new Date().getFullYear(), 0, 1);
  }
  private getNumberCurrentYear(): any {
    return getYear(new Date());
  }
  private resolveOperator(o: string) {
    if (o == 'get') return '>=';
    if (o == 'let') return '<=';
    return o;
  }

  private resolvePattern(f: FilterConfig, count: number, guid: string) {
    if (!f.pattern && !f.staticValue) return;
    f.id = count;
    if (f.pattern === this.today || f.pattern === this.todayDeprectaed) {
      f.value = new Date();
      return;
    }
    if (f.pattern === this.foy || f.pattern === this.foyDeprectaed) {
      f.value = this.getFirstOfYear();
      return;
    }
    if (f.pattern === this.cyn || f.pattern === this.cynDeprecated) {
      f.value = this.getNumberCurrentYear();
      return;
    }
    if (f.pattern === this.uId || f.pattern === this.uIdDeprecated) {
      f.value = this.getUserId();
      return;
    }

    if (
      (f.pattern === this.sessionParam ||
        f.pattern === this.sessionParamDeprecated) &&
      f.staticValue
    ) {
      let value = this.pAndPService.getSessionParamValue(f.staticValue, guid);
      // if (value != undefined) {
      f.skip = false;
      f.value = value;
      return;
      // } else {
      //         //   f.skip = true;
      //   f.value = '';
      // }
    }

    if (
      (f.pattern === this.staticValue ||
        f.pattern === this.staticValueDeprecated) &&
      f.staticValue
    ) {
      if (
        f.staticValue &&
        f.staticValue.startsWith('#') &&
        f.staticValue.endsWith('#')
      ) {
        var date = f.staticValue.replace('#', '');
        date = date.replace('#', '');
        var parts: any[] = [];
        if (date.indexOf('-') > 0) {
          parts = date.split('-');
        } else if (date.indexOf('/')) {
          parts = date.split('/');
        } else if (date.indexOf('\\')) {
          parts = date.split('\\');
        }
        if (parts && parts.length == 3) {
          var month = parts[1] - 1; // mesi partono da 0
          f.value = new Date(parts[2], month, parts[0]);
        } else {
          f.value = f.staticValue;
        }
      } else {
        f.value = f.staticValue;
      }
    }
  }

  resolvePatternAfterFirstLoad(f: FilterConfig, count: number, guid: string) {
    if (!f.staticValue) {
      return;
    }
    let value = this.pAndPService.getSessionParamValue(f.staticValue, guid);
    if (value != undefined) {
      f.skip = false;
      f.value = value;
      return;
    } else {
      f.skip = true;
      f.value = '';
    }
  }
  private create(f: FilterConfig): any {
    if (!f.operator) return;
    let r = [f.field, this.resolveOperator(f.operator), f.value];
    return r;
  }
  processValue(value: any, dataType: any): any {
    if (typeof value != 'string') {
      return value;
    }
    var res: any = null;
    switch (dataType) {
      case 'date':
      case 'datetime':
        res = new Date(value);
        break;
      case 'number':
        res = +value;
        break;
      default:
        res = value;
        break;
    }
    return res;
  }
  private createFilterFroSiaSessionParam(param: SiaSessionParam): any {
    if (!param.operator) return null;
    var value = this.processValue(param.value, param.dataType);
    let r = [param.field, this.resolveOperator(param.operator), value];
    return r;
  }

  private generateFiltersTree(pref: FilterConfig[]) {
    let ff: any[] = [];
    let tree: any[] = [];
    if (!pref) return tree;
    pref.forEach((f) => {
      if (f && !f.skip) {
        ff.push(this.create(f));
      }
    });

    let fr = true;
    let a = 'and';

    ff.forEach((x) => {
      if (fr) {
        fr = false;
      } else {
        tree.push(a);
      }
      tree.push(x);
    });

    return tree;
  }

  generateFiltersTreeFromSiaSessionParams(params: SiaSessionParam[]) {
    let ff: any[] = [];
    let tree: any[] = [];
    if (!params) return tree;
    params = params.filter((param) => param != undefined);
    params.forEach((par) => {
      if (par) {
        var f = this.createFilterFroSiaSessionParam(par);
        ff.push(f);
      }
    });

    let fr = true;
    let a = 'and';

    ff.forEach((x) => {
      if (fr) {
        fr = false;
      } else {
        tree.push(a);
      }
      tree.push(x);
    });

    return tree;
  }

  generatePreFiltersFromTree(tree: any): FilterConfig[] {
    var res: FilterConfig[] = [];
    if (!tree) return res;
    var array: any[] = [];
    var index = 0;
    tree.forEach((element: any) => {
      if (element != 'and') {
        array[index] = element;
        if (index == 2) {
          var filterConfig = this.createFilterConfig(array);
          res.push(filterConfig);
          array = [];
          index = 0;
        } else {
          index += 1;
        }
      } else {
      }
    });
    return res;
  }
  private createFilterConfig(element: any) {
    var res: FilterConfig = {
      widget: undefined,
      field: element[0],
      operator: element[1],
      pattern: '@StaticValue',
      staticValue: element[2],
    };
    return res;
  }

  //#endregion

  //#region public methods
  getSessionParamValue(paramName: string, guid: string) {
    return this.pAndPService.getSessionParamValue(paramName, guid);
  }

  resolvePatterns(
    info: { controlId: string; prefilters?: FilterConfig[] },
    guid: string,
  ) {
    if (info.prefilters) {
      let count = 0;
      info.prefilters.forEach((f) => {
        this.resolvePattern(f, count, guid);
        count += 1;
      });
    }
  }
  resolvePatternsAfterFirstLoad(
    info: {
      controlId: string;
      prefilters: FilterConfig[];
    },
    guid: string,
  ) {
    if (info.prefilters) {
      let count = 0;
      info.prefilters.forEach((f) => {
        this.resolvePatternAfterFirstLoad(f, count, guid);
        count += 1;
      });
    }
  }
  generateTreeFilters(info: { controlId: string; prefilters: FilterConfig[] }) {
    if (!info || !info.controlId) return [];
    if (!info.prefilters) return [];
    let tree = this.generateFiltersTree(info.prefilters);
    return tree;
  }

  popupToggle() {
    this._popup$.next(true);
  }

  closePopup() {
    this._popup$.next(false);
  }
  //#endregion
}
